<template>
  <div class="select-vehicle multi-select-div">
    <button class="about-btn" @click="openModal"><font-awesome-icon icon="info-circle" /> About the data</button>
    <div class="filter-container">
       <div class="input-container">
        <label for="class-select">Vehicle classes</label>
        <VueMultiselect
          id="class-select"
          v-model="selectedClass"
          track-by="code"
          label="name"
          :options="allClassOptions"
          @open="openMultiselect('class-select')"
          @close="closeMultiselect('class-select')"
          :multiple="true">
        </VueMultiselect>
      </div>
      <div class="input-container">
        <label for="vocation-select">Vehicle vocations</label>
        <VueMultiselect
          id="vocation-select"
          v-model="selectedVocation"
          track-by="code"
          label="name"
          :options="allVocationOptions"
          @open="openMultiselect('vocation-select')"
          @close="closeMultiselect('vocation-select')"
          :multiple="true">
        </VueMultiselect>
      </div>
    </div>
  </div>
</template>

<script setup>
import VueMultiselect from 'vue-multiselect';
import { computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();
const route = useRoute();

function openModal() {
  store.commit('setDashboardModal', true);
}

onMounted(() => {
  document.querySelector('div[aria-owns="listbox-class-select"').setAttribute('aria-expanded', false);
  document.querySelector('div[aria-owns="listbox-vocation-select"').setAttribute('aria-expanded', false);
});

function openMultiselect(selectId) {
  document.querySelector(`div[aria-owns="listbox-${selectId}"`).setAttribute('aria-expanded', true);
}

function closeMultiselect(selectId) {
  document.querySelector(`div[aria-owns="listbox-${selectId}"`).setAttribute('aria-expanded', false);
}

const allVocationOptions = computed(() => store.getters.getAllVehicleVocations);
const allClassOptions = computed(() => store.getters.getAllVehicleClasses);

function setRoute(valueArr, selectType) {
  const selectedArr = valueArr.map((item) => item.code);
  const newestItem = selectedArr[selectedArr.length - 1];
  const hasAll = selectedArr.length > 1 && selectedArr.includes('all');
  if (selectedArr.length === 0 || newestItem === 'all') {
    router.push({
      query: {
        ...route.query,
        [selectType]: undefined,
      },
    });
  } else if (hasAll) {
    // deselects 'all' if other items are selected
    const filteredArr = selectedArr.filter((item) => item !== 'all');
    router.push({
      query: {
        ...route.query,
        [selectType]: filteredArr,
      },
    });
  } else {
    router.push({
      query: {
        ...route.query,
        [selectType]: selectedArr,
      },
    });
  }
}

const selectedVocation = computed({
  get: () => store.getters.getSelectedVocationObject,
  set: (value) => {
    setRoute(value, 'vocation');
  },
});
const selectedClass = computed({
  get: () => store.getters.getSelectedClassObject,
  set: (value) => {
    setRoute(value, 'class');
  },
});
</script>
